import "./customLoader.css";

const CustomLoader = ({
  size = 50,
  color = "#474554",
  text = "Loading...",
}) => {
  return (
    <div className="custom-loader-wrapper">
      <div
        className="newtons-cradle"
        style={{
          "--uib-size": `${size}px`,
          "--uib-color": color,
        }}
      >
        <div className="newtons-cradle__dot"></div>
        <div className="newtons-cradle__dot"></div>
        <div className="newtons-cradle__dot"></div>
        <div className="newtons-cradle__dot"></div>
      </div>

      {text && <p className="loader-text">{text}</p>}
    </div>
  );
};

export default CustomLoader;
